import { Module } from "vuex";
import { RootState } from "@/store/types";
import { pushStatistic } from "./statistic";
import { applicationAttribute } from "./attributes";
import { pushApplication } from "./application";
import { pushTemplate } from "./templates";
import { groupsApplications } from "./groups_application";

export const pushModule: Module<{modules: any}, RootState> = {
  modules: {
    pushStatistic,
    pushApplication,
    applicationAttribute,
    pushTemplate,
    groupsApplications
  },
};
